import React, { createRef, useEffect, useState } from 'react'
import { Switch, Route } from 'react-router-dom'
import store from '@/core/store'
import classNames from 'classnames'

import { StickyNotification } from '@/components/Notification/StickyNotification'
import { SideMenu } from '@/components/SideMenu/SideMenu'
import { FeedContent } from '@/pages/HomePage/FeedContent/FeedContent'
import { DraftList } from '@/pages/HomePage/DraftsList/DraftsList'

import './HomePage.scoped.sass'
import commonsService from '@/services/commons.service'
import sessionService from '@/app-domains/user/session/session.service'
import modalService from '@/services/modal.service'
import { MenuBottom } from '@/components/SideMenu/components/MenuBottom/MenuBottom'
import { HistorySection } from './HistorySection/HistorySection'
import ContactProfileView from './ContactProfileView/ContactProfileView'
import WelcomeModalRouter from '@/components/TrialModals/WelcomeModalRouter/WelcomeModalRouter'

export function HomePage () {
  const [showStickyNotification, setShowStickyNotification] = useState(false)
  const [showUserMenu, setShowUserMenu] = useState(false)
  const isMobile = commonsService.isMobile()
  // eslint-disable-next-line
  const [selectedMessageId, setSelectedMessageId] = useState(null)
  const article = createRef()
  // const aside_right = createRef(

  useEffect(() => {
    if (!sessionService.isUserLogged()) {
      return commonsService.goToPage('/auth')
    }
    let isMounted = true
    if (isMounted) {
      store.on('NOTIFICATIONS:toggle', (show) => {
        setShowStickyNotification(show)
      })
      store.on('UI:show_menu', (showUserMenu) => setShowUserMenu(showUserMenu))
    }
    return () => { isMounted = false }
  }, [])

  const welcomeModalFunction = () => modalService.open(<WelcomeModalRouter closeModal={() => modalService.close()}/>, true)
  const welcomeModalFunctionDelayed = () => setTimeout(welcomeModalFunction, 200)

  const getWelcomeModal = () => {
    const query = new URLSearchParams(window.location.search)
    const code = query?.get('welcome')

    if (code === 'true') {
      /*
      Used for asking the users to send a first message.
      saveItemInLocalStorage('onboarding:firstMessage', true)
      */
      welcomeModalFunctionDelayed()
    }
  }

  return (
    <main className={'home-page ' + (showUserMenu ? 'show_user_menu' : '')}>
      {showStickyNotification ? <StickyNotification/> : ''}
      <div className="layout">
        {getWelcomeModal()}
        <SideMenu/>
        <article className={classNames('feed-container', {
          'write-message': window?.location?.pathname?.includes('write')
        })} ref={article}>
          <Switch>
            <Route exact path={'/'}>
              <FeedContent selectedMessageId={selectedMessageId}/>
            </Route>
            <Route exact path={'/drafts'}>
              <DraftList />
            </Route>
            <Route exact path={'/history'}>
              <HistorySection/>
            </Route>
            <Route exact path={'/boxes'}>
              <FeedContent/>
            </Route>
            <Route exact path={'/contacts'}>
              <ContactProfileView />
            </Route>
          </Switch>
          <MenuBottom className='mb-show' isMobile={isMobile}/>
        </article>
      </div>
    </main>
  )
}
